__turbopack_context__.v({
  "label": "size-option-module-scss-module__FyQlbG__label",
  "note": "size-option-module-scss-module__FyQlbG__note",
  "root": "size-option-module-scss-module__FyQlbG__root",
});
